"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _tabbable = require("tabbable");
var _focusTrap = _interopRequireDefault(require("../focus-trap"));
require("./modal-portal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ModalPortal = function ModalPortal(_ref) {
  var _modal$modalRootProps;
  var ariaModal = _ref.ariaModal,
    closeModal = _ref.closeModal,
    modal = _ref.modal,
    targetElement = _ref.targetElement;
  if (!modal.ariaLabel && !modal.ariaLabelledBy && !(modal !== null && modal !== void 0 && (_modal$modalRootProps = modal.modalRootProps) !== null && _modal$modalRootProps !== void 0 && _modal$modalRootProps['aria-label'])) {
    // eslint-disable-next-line no-console
    console.warn('No accessible name provided for this modal. Please pass either an ariaLabel or ariaLabelledBy in the `openModal()` signature. ariaLabelledBy should reference the id of an element with descriptive text in your modal content, such as a heading.');
  }
  var modalRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _modalRef$current;
    var firstFocusable = (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 || (_modalRef$current = _modalRef$current.querySelectorAll('[tabIndex="-1"]')) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current[0];
    var firstTabbable = modalRef.current ? (0, _tabbable.tabbable)(modalRef.current)[0] : null;
    var focusTarget = firstTabbable || firstFocusable || modalRef.current;
    focusTarget.focus();
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_reactDom["default"].createPortal(/*#__PURE__*/_react["default"].createElement("div", _extends({
    "aria-label": modal.ariaLabel,
    "aria-labelledby": modal.ariaLabelledBy,
    "aria-modal": ariaModal,
    className: "sb-modal-root",
    ref: modalRef,
    role: "dialog"
  }, modal.modalRootProps), /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], {
    wrapWithDiv: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-modal-mask",
    onClick: function onClick() {
      return closeModal();
    }
  }), /*#__PURE__*/_react["default"].createElement(modal.Component, modal.componentProps))), targetElement));
};
var _default = exports["default"] = ModalPortal;